/**
 * Формирует подписи истории ПЛАНа по неизменяемым snapshot-версиям.
 * Утилита не читает store и не определяет состояние интерфейса.
 */
// Формирует подпись версии без специальных кодов калькуляторов.
// Различие preset id между соседними версиями означает смену калькулятора.
export function hasCalculatorPresetChanged(currentPresetId, previousPresetId) {
  if (currentPresetId == null || previousPresetId == null) return false;

  return String(currentPresetId) !== String(previousPresetId);
}

// Возвращает предметный заголовок версии или явно отмечает смену калькулятора.
export function getCalculationHistoryTitle(calculations, index) {
  const calculation = calculations[index];
  const previousCalculation = calculations[index + 1];
  const presetName = calculation?.preset_snapshot?.name || "Калькулятор";
  const calculatorChanged =
    calculation?.status !== "failed"
    && previousCalculation
    && hasCalculatorPresetChanged(
      calculation.calculator_preset_id,
      previousCalculation.calculator_preset_id
    );

  return calculatorChanged
    ? `Смена калькулятора → «${presetName}»`
    : presetName;
}
